import { CommonModule } from '@angular/common';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { NgLetDirective } from '@core/frontend-shared/utils';
import { MembershipProfileInfoboxComponent } from './membership-profile-infobox.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-message", 1);
    i0.ɵɵtext(1, " Ihre Zugang wurde noch nicht aktiviert, da noch keine Zahlung eingegangen ist. Bitte schlie\u00DFen Sie die Bestellung zuerst ab. Ist etwas schief gelaufen? Gerne hilft unser Supportteam weiter. ");
    i0.ɵɵelementStart(2, "button", 2);
    i0.ɵɵlistener("click", function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_0_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.payNow());
    });
    i0.ɵɵelementEnd()();
  }
}
function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-message", 3);
    i0.ɵɵtext(1, " Ihre Mitgliedschaft ist abgelaufen. ");
    i0.ɵɵelementStart(2, "button", 5);
    i0.ɵɵlistener("click", function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Conditional_0_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.renew());
    });
    i0.ɵɵelementEnd()();
  }
}
function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-message", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 6);
    i0.ɵɵlistener("click", function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Conditional_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.renew());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const status_r5 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" Ihr Zugang ist noch ", status_r5.membershipDaysLeft, " Tage g\u00FCltig. ");
  }
}
function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Conditional_0_Template, 3, 0, "ui-message", 3);
    i0.ɵɵconditionalCreate(1, MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Conditional_1_Template, 3, 1, "ui-message", 4);
  }
  if (rf & 2) {
    const status_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵconditional(status_r5.hasExpiredMembership ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(status_r5.membershipIsValid && status_r5.membershipDaysLeft < 30 ? 1 : -1);
  }
}
function MembershipStatusMessageComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_0_Template, 3, 0, "ui-message", 1)(1, MembershipStatusMessageComponent_ng_template_0_Conditional_0_Conditional_1_Template, 2, 2);
  }
  if (rf & 2) {
    const status_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(status_r5.membershipPaymentPending ? 0 : 1);
  }
}
function MembershipStatusMessageComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MembershipStatusMessageComponent_ng_template_0_Conditional_0_Template, 2, 1);
  }
  if (rf & 2) {
    const status_r5 = ctx.$implicit;
    i0.ɵɵconditional(status_r5.loggedIn ? 0 : -1);
  }
}
export let MembershipStatusMessageComponent = /*#__PURE__*/(() => {
  class MembershipStatusMessageComponent extends MembershipProfileInfoboxComponent {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMembershipStatusMessageComponent_BaseFactory;
        return function MembershipStatusMessageComponent_Factory(__ngFactoryType__) {
          return (ɵMembershipStatusMessageComponent_BaseFactory || (ɵMembershipStatusMessageComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MembershipStatusMessageComponent)))(__ngFactoryType__ || MembershipStatusMessageComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipStatusMessageComponent,
        selectors: [["membership-status-message"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "ngLet"], ["type", "warn", 1, "membership-message", "message-payment-pending"], ["uiButton", "", "label", "Zahlung abschlie\u00DFen", 1, "ui-button-outline", "small", 3, "click"], ["type", "warn", 1, "membership-message", "message-expired"], ["type", "info", 1, "membership-message", "message-days-left"], ["uiButton", "", "label", "Mitgliedschaft fortsetzen", 1, "ui-button-outline", "small", 3, "click"], ["uiButton", "", "label", "jetzt verl\u00E4ngern", 1, "ui-button-outline", "small", 3, "click"]],
        template: function MembershipStatusMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MembershipStatusMessageComponent_ng_template_0_Template, 1, 1, "ng-template", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(1, 1, ctx.membershipStatus$));
          }
        },
        dependencies: [CommonModule, UiMessageComponent, UiButtonComponent, NgLetDirective, i1.AsyncPipe],
        styles: [".membership-message[_ngcontent-%COMP%]{max-width:560px;margin:20px auto}\n\n/*# sourceMappingURL=membership-status-message.component.ts-angular-inline--87.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return MembershipStatusMessageComponent;
})();